import { render, staticRenderFns } from "./NavbarWalletSessionDisconnected.vue?vue&type=template&id=72634abc&scoped=true"
import script from "./NavbarWalletSessionDisconnected.vue?vue&type=script&lang=ts"
export * from "./NavbarWalletSessionDisconnected.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72634abc",
  null
  
)

export default component.exports